// extracted by mini-css-extract-plugin
export default {"preview-section-modal":"PreviewSectionModal_preview-section-modal__5Sy5I","header-wrapper":"PreviewSectionModal_header-wrapper__LN6Z5","content":"PreviewSectionModal_content__2vPAh"};